import React from 'react';
import { Redirect, Route, Switch } from "react-router";
import { List } from "./List";

function LogNotificaciones({ match }) {
    const { path } = match;

    return (
        <Switch>
            <Route exact path={path} component={List} />
            <Redirect from="*" to={{
                                pathname: List
                            }}/>
        </Switch>
    ); 
}

export { LogNotificaciones };

